import * as $ from "jquery";
import * as _ from "lodash";
import * as ko from "knockout";
import { Command } from "../command";
import { CommandType } from "../commandType";
import { Application } from "../application";
import { BufferItemType } from "../buffer/bufferItemType";
import { ActivePanel } from "../state/activePanel";
import { BufferItem } from "../buffer/bufferItem";
import { ClipboardUtility } from "../utilities/clipboardUtility";

export class CopyRowCommand implements Command {
    constructor(private app: Application) {

    }

    type: CommandType = CommandType.CopyRow;    
    canExecute = ko.computed(() => {
        let estimate = this.app.state.estimate();
        if(this.app.state.activePanel() == ActivePanel.Estimate) {
            let estimate = this.app.state.estimate();
            if (!estimate) return false;
            let selectedRow = estimate.selectedRow();
            if (selectedRow == null) return false;
            let totalRow = _.find(selectedRow, function(obj) {
                return obj.type > 1;
            });
            if (totalRow) return false;
            return selectedRow.length > 0;
        }
        if(this.app.state.activePanel() == ActivePanel.Costbook) {
            let costbook = this.app.state.costbook();
            if (!costbook) return false;
            let selectedRow = costbook.selectedRow();
            if (selectedRow == null) return false;
            return selectedRow.length > 0 && _.some(selectedRow, x => x.copiable);
        }        
        return false;
    });

    canNotExecute = ko.computed(() => {
        return !this.canExecute();
    });

    execute(pasteToTheEnd: boolean): JQueryPromise<any> {
        if (!this.canExecute())return $.Deferred().reject().promise();
        this.app.state.buffer([]);
        if (this.app.state.activePanel() == ActivePanel.Estimate) {
            let estimate = this.app.state.estimate();
            if (!estimate) return $.Deferred().reject().promise();
            let buffer : BufferItem[] = [];
            let items = _.sortBy(estimate.selectedRow(), ['order']);
            for (let row of  items) {
                buffer.push({
                    type: BufferItemType.estimateRow,
                    data: row,
                    handled: false,
                    pasteToTheEnd: false
                });
            }
            this.app.state.buffer(buffer);
            ClipboardUtility.copyRowsToClipboard(buffer);            
            return $.Deferred().resolve().promise();
        }
        if(this.app.state.activePanel() == ActivePanel.Costbook) {
            let costbook = this.app.state.costbook();
            if (!costbook) return $.Deferred().reject().promise();
            let buffer : BufferItem[] = [];
            let items = _.sortBy(costbook.selectedRow(), ['index']);
            for (let row of _.filter(items, x => x.copiable && !x.isSectionRow)) {
                buffer.push({
                    type: BufferItemType.costRow,
                    data: row,
                    handled: false,
                    pasteToTheEnd: pasteToTheEnd
                });
            }
            this.app.state.buffer(buffer);
            ClipboardUtility.copyRowsToClipboard(buffer);
            return $.Deferred().resolve().promise();
        }        
        return $.Deferred().reject().promise();
    }
    name = "Copy Row";
}


// WEBPACK FOOTER //
// ./ClientApp/services/commands/copyRowCommand.ts